import appConstants from "../../../../../../../appConstants";
import { PAYMENT_MODES } from "../../common/constants";
const { FREIGHT_PAYMENT_MODES, COD_PAYMENT_MODES } = PAYMENT_MODES;

const isFreightCheckNumberRequired = (freightPaymentType) => {
  return FREIGHT_PAYMENT_MODES.CHECK === freightPaymentType;
};

const isFreightAmountRequired = (freightPaymentType) => {
  return FREIGHT_PAYMENT_MODES.COMPANY_ACCOUNT !== freightPaymentType;
};

const hasPendingAmount = (amount) => {
  return Number(amount) > 0;
};

const getPaymentTypeLabelFromCode = ({ paymentType, paymentTypeCode }) => {
  if (paymentType === "freightPaymentType") {
    return FREIGHT_PAYMENT_MODES.FREIGHT_PAYMENT_MODELIST.find(
      (data) => data.code === paymentTypeCode
    )?.description;
  } else if (paymentType === "codPaymentType") {
    return COD_PAYMENT_MODES.COD_PAYMENT_MODELIST.find(
      (data) => data.code === paymentTypeCode
    )?.description;
  }
  return "";
};

const isPaymentDetailsRequired = ({
  deliveryStatus,
  codAmount,
  freightAmount,
}) => {
  return (
    ![appConstants.DELIVERY_CODE.RTN, appConstants.DELIVERY_CODE.SND].includes(
      deliveryStatus
    ) &&
    (codAmount > 0 || freightAmount > 0)
  );
};

const convertToUSDollars = (value) => {
  return Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  });
};

const getDefaultPaymentInfo = () => {
  return {
    freightPaymentType: null,
    freightAmountCollected: null,
    freightCheckNumber: null,
    codPaymentType: null,
    codCheckNumber: null,
    codAmountCollected: null,
  };
};

const populatePaymentAmount = ({
  freightAmount,
  codAmount,
  paymentTypeFieldName,
  paymentTypeValue,
}) => {
  if (FREIGHT_PAYMENT_MODES.COMPANY_ACCOUNT === paymentTypeValue?.value) {
    return {"freightAmountCollected": 0}
  } else if(paymentTypeFieldName === "freightPaymentType") {
    return {"freightAmountCollected": freightAmount}
  } else if(paymentTypeFieldName === "codPaymentType") {
    return {"codAmountCollected": codAmount}
  }
};

const getPaidCharge = (originalAmount, providedAmount) => {
  return originalAmount - providedAmount;
};

const getPaymentErrorInfo = ({ data, field, value }) => {
  const { deliveryStatus, freightAmount, freightPaymentType, codAmount } = data;
  const payment = isPaymentDetailsRequired({
    deliveryStatus: deliveryStatus,
    codAmount: codAmount,
    freightAmount: freightAmount,
  });
  const pendingFreightAmount = hasPendingAmount(freightAmount);
  const pendingCodAmount = hasPendingAmount(codAmount);
  if (payment) {
    switch (field) {
      case "freightPaymentType":
        return pendingFreightAmount > 0 && !value ? "* required" : null;
      case "freightCheckNumber":
        return pendingFreightAmount > 0 &&
          isFreightCheckNumberRequired(freightPaymentType?.value) &&
          !value
          ? "* required"
          : null;
      case "freightAmountCollected":
        return pendingFreightAmount > 0 &&
          isFreightAmountRequired(freightPaymentType?.value) &&
          !value
          ? "* required"
          : null;
      case "codPaymentType":
        return pendingCodAmount > 0 && !value ? "* required" : null;
      case "codCheckNumber":
        return pendingCodAmount > 0 && !value ? "* required" : null;
      case "codAmountCollected":
        return pendingCodAmount > 0 && !value ? "* required" : null;
      default:
        return null;
    }
  } else {
    return null;
  }
};

export {
  isFreightCheckNumberRequired,
  getPaymentTypeLabelFromCode,
  isFreightAmountRequired,
  isPaymentDetailsRequired,
  convertToUSDollars,
  getDefaultPaymentInfo,
  getPaymentErrorInfo,
  populatePaymentAmount,
  getPaidCharge,
};
